import { useEffect } from 'react';
export function useDocumentTitle(title, titleOnUnmount) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    return () => {
      if (titleOnUnmount) {
        document.title = titleOnUnmount;
      }
    };
  }, [title, titleOnUnmount]);
}